angular.module('public.security-manager.employee').component('gccsEmployeeProfileApproveClients', {
  template: require('./template.pug'),
  controller: 'EmployeeProfileApproveClientsController',
  bindings: {
    employee: '<',
    clients: '<',
    selectedClientId: '='
  }
});
